import React, { PureComponent } from "react";

export default class TitleComponent extends PureComponent {
    render() {
        return <p className={["miyosmart-title"].join(" ")}>{this.props.title}</p>;
    }
}
